<script lang="ts">
import { defineComponent, computed } from 'vue'
import { createNamespacedHelpers } from 'vuex-composition-helpers'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import { useI18n } from '../../setup/setup-i18n'

const { useGetters: useLoginDomainStoreGetters } = createNamespacedHelpers('LoginDomain')

export default defineComponent({
  name: 'ResetPasswordSentPage',

  components: {
    DefaultLayout,
  },

  setup() {

    const { t, locale } = useI18n()

    const { loginHelpUrl, resetPasswordHelpUrlLocales } = useLoginDomainStoreGetters(['loginHelpUrl', 'resetPasswordHelpUrlLocales'])

    const localisedHelpUrl = computed(() => {
      if (!resetPasswordHelpUrlLocales.value) {
        return ''
      }
      return resetPasswordHelpUrlLocales.value[locale] || resetPasswordHelpUrlLocales.value.en
    })

    return {
      t,
      loginHelpUrl,
      localisedHelpUrl,
    }

  },

})

</script>

<template>
  <default-layout
    :title="t('ResetPasswordSentPage.pageTitle')"
    :sub-title="t('ResetPasswordSentPage.subTitle')"
  >
    <sm-button
      type="primary"
      class="reset-password-link"
      :to="{ name: 'ResetPasswordPage' }"
    >
      {{ t('ResetPasswordSentPage.resendEmailLink') }}
    </sm-button>
    <div
      v-if="loginHelpUrl"
      class="login-support"
    >
      <a
        class="login-help-url"
        :href="localisedHelpUrl || loginHelpUrl"
        target="_blank"
      >
        {{ t('ResetPasswordSentPage.troubleLoggingInLink') }}
      </a>
    </div>
  </default-layout>
</template>

<style lang="scss" scoped>
.login-support {
  display: flex;
  justify-content: flex-end;
}

.login-support .login-help-url {
  @apply mt-2.5 text-sm;
}

.reset-password-link {
  @apply w-full mt-2.5 text-sm;
}

::v-deep .reset-password-link .sm-button__content {
  @apply block text-center;
}

::v-deep .reset-password-link .sm-button__content .router-link-active {
  @apply text-white;
}

</style>
